export const environment = {
  production: true,
  apiURL: 'https://nalo-test.herokuapp.com/v1/',
  publishable_key: 'pk_test_L8Jb3NcEBazdEfXkiwDKfzEa00JwINmZSq'
};
